import React from 'react';
import { Box, Collapse } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useConnectivity } from '../../hooks/useConnectivity';

// Banner global exibido no topo quando o app perde conexão.
// Diferencia "sem internet" (rede do navegador) de "servidor indisponível" (backend não responde).
export default function OfflineBanner() {
  const { isOffline, browserOnline } = useConnectivity();

  const message = !browserOnline
    ? 'Você está offline. Verifique sua conexão com a internet.'
    : 'Servidor indisponível no momento. Tentando reconectar…';

  return (
    <Collapse in={isOffline}>
      <Box
        role="status"
        aria-live="polite"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          py: 0.75,
          px: 2,
          backgroundColor: 'warning.main',
          color: 'warning.contrastText',
          fontSize: '0.875rem',
          fontWeight: 500,
        }}
      >
        <WifiOffIcon fontSize="small" />
        {message}
      </Box>
    </Collapse>
  );
}
